import * as React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton
} from '@mui/material';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import { useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { t } from 'i18next';
import { useAppDispatch } from '../../redux_store/reduxStore';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { addTaxes } from '../../redux_store/slices/taxesSlice';
import * as Button from '../../components/buttons/BakeasyButtons';
import { Close } from '@mui/icons-material';
import { taxRateWithDecimalPoint } from '../../constants/Regex';

export const AddTax = (props: any) => {
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [name, setName] = useState<string>('');
  const [rate, setRate] = useState<string>('');

  function handleClose() {
    myContext.setDialog({ open: false });
    props?.onBack();
  }

  const checkValidity = (): boolean => {
    if (!name) {
      let msg = `${t('TAX_DESCRIPTION_IS_REQUIRED')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }
    if (!rate) {
      let msg = `${t('TAX_RATE_IS_REQUIRED')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }
    return true;
  };

  async function onAddSubmit() {
    if (!checkValidity()) {
      return;
    }

    let payload = {
      countryId: props?.params?.supplierCountry?._id,
      taxName: name + ' - ' + rate + '%'
    };

    await dispatch(addTaxes(payload));
    handleClose();
  }

  return (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('ADD_TAX')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: theme => theme.palette.grey[500] }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent sx={{ margin: 0 }}>
        <Grid item xs={12} sm={12}>
          <BakeasyTextField
            key={'TAX_DESCRIPTION'}
            label={t('TAX_DESCRIPTION')}
            placeHolder={t('ENTER_TAX_DESCRIPTION')}
            type="text"
            name="name"
            value={name}
            maxLength={30}
            required={true}
            helperText="e.g. USA - GST"
            onChange={(event: any) => {
              setName(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} mt={1}>
          <BakeasyTextField
            key={'TAX_RATE'}
            label={t('TAX_RATE')}
            placeHolder={t('ENTER_TAX_RATE')}
            type="text"
            name="name"
            value={rate}
            maxLength={10}
            required={true}
            regexPattern={taxRateWithDecimalPoint}
            onChange={(event: any) => {
              setRate(event.target.value);
            }}
          />
        </Grid>
      </DialogContent>
      <DialogActions sx={{ margin: 1 }}>
        <Button.Cancel onClick={handleClose} />
        <Button.Create
          onClick={() => {
            onAddSubmit();
          }}
        />
      </DialogActions>
    </>
  );
};
